//统计分析
const ShareParkingDayReport = () => import(/*webpackChunkName:'finance'*/'@/page/share-report-day/share-report-day.vue')
const ShareParkingMonthReport = () => import(/*webpackChunkName:'finance'*/'@/page/share-report-month/share-report-month.vue')
const RouteTemp = () => import(/*webpackChunkName:'finance'*/'@/page/commons/routeTemp.vue')

export const shareReport= {}={
    path: '/main/finance/share-Report',
    name: '共享报表',
    meta: {
        requireAuth: true,

    },
    component: RouteTemp,
    children: [

        {
            path: '/main/finance/share-report-day',
            name: '共享日报',
            meta: {
                requireAuth: true,
            },
            component: ShareParkingDayReport
        }, {
            path: '/main/finance/share-report-month',
            name: '共享月报',
            meta: {
                requireAuth: true,
            },
            component: ShareParkingMonthReport
        }, 
        // {
        //     path: '/main/finance/groupDayReport',
        //     name: '集团日报',
        //     meta: {
        //         requireAuth: true,
        //     },
        //     component: ParkingGroupDayReport
        // }, {
        //     path: '/main/finance/groupMonthReport',
        //     name: '集团月报',
        //     meta: {
        //         requireAuth: true,
        //     },
        //     component: ParkingGroupMonthReport
        // }
    ]
}